const FieldType = require('@/lib/CustomFields/FieldType');
const { calculateAgeFromDob } = require('@/functions/age');
const { getAllFieldGroupsFromOrder } = require('./fieldFunctions');

/**
 * @constructor
 */
const FieldValidator = function () {

};

FieldValidator.prototype = {
    /**
     * @param {FieldInstance} fieldInstance
     *
     * @return {boolean}
     */
    validateFieldInstance(fieldInstance) {
        fieldInstance.clearError();

        // Ensure required fields are filled out.
        if (fieldInstance.field.required && !fieldInstance.hasValue) {
            if (fieldInstance.field.hasMultipleOptions) {
                fieldInstance.setError('FIELDS.ERROR--PLEASE_FILL--OPTIONS');
            } else if (fieldInstance.field.hasOptions) {
                fieldInstance.setError('FIELDS.ERROR--PLEASE_FILL--OPTION');
            } else {
                fieldInstance.setError('FIELDS.ERROR--PLEASE_FILL');
            }
            return false;
        }

        if (fieldInstance.field.type === FieldType.DOB) {
            // calculateAge will set isValid and error on the instance if needed.
            // No need to check if the field is empty.
            // Validation will already have failed above if it is required but empty.
            try {
                fieldInstance.age = fieldInstance.value
                    ? calculateAgeFromDob(fieldInstance.value)
                    : null;
            } catch (e) {
                console.log('dob error', e);
                fieldInstance.setError(e.langKey);
                return false;
            }
        }

        return true;
    },

    /**
     * @param {FieldGroup} fieldGroup
     *
     * @return {boolean}
     */
    validateFieldGroup(fieldGroup) {
        // Returns true if there are no invalid fields.
        return fieldGroup.instances.map((instance) => this.validateFieldInstance(instance))
            .filter((isValid) => !isValid)
            .length === 0;
    },

    /**
     * @param {FieldGroup[]} fieldGroups
     *
     * @return {boolean}
     */
    validateFieldGroups(fieldGroups) {
        // Returns true if there are no invalid groups.
        return fieldGroups.map((fieldGroup) => this.validateFieldGroup(fieldGroup))
            .filter((isValid) => !isValid)
            .length === 0;
    },

    /**
     * @param {Cart} cart
     *
     * @return {boolean}
     */
    validateCartFields(cart) {
        let fieldGroups = getAllFieldGroupsFromOrder(cart);
        return this.validateFieldGroups(fieldGroups);
    },
};

module.exports = FieldValidator;
